// extracted by mini-css-extract-plugin
export var FollowUsIcon = "style-module--FollowUsIcon--4b923";
export var FollowUsLinkWrapper = "style-module--FollowUsLinkWrapper--ec2be";
export var FollowUsWrapper = "style-module--FollowUsWrapper--c2744";
export var ProjectsButton = "style-module--ProjectsButton--5fe30";
export var SuccessModalWrapper = "style-module--SuccessModalWrapper--ef682";